<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'customerCode'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-else-if="scope.column.property === 'lineNumber'"
                  @click="toLine(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <span v-else-if="scope.column.property === 'remark'">
                  <el-popover
                    v-if="scope.row[scope.column.property].length > 10"
                    :content="scope.row[scope.column.property]"
                    trigger="hover"
                  >
                    <section slot="reference">
                      <span class="primary">{{
                        scope.row[scope.column.property].substr(0, 9) + '...'
                      }}</span>
                    </section>
                  </el-popover>
                  <span v-else>{{ scope.row[scope.column.property] }}</span>
                </span>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160">
            <template slot-scope="scope">
              <section>
                <qx-permpisions
                  permpisions=""
                  v-if="scope.row.remark == '导出成功'"
                >
                  <span class="primary cur" @click="downloadFile(scope.row)"
                    >下载文件</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  exportList,
} from 'api/system';
import {
  downloadExcelFileAsyn,
} from '@qx/utils';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'userName', label: '操作人', fixed: true },
          { prop: 'bizName', label: '业务名称' },
          { prop: 'batchId', label: '批次号' },
          { prop: 'remark', label: '状态', w: 180 },
          { prop: 'createDate', label: '创建时间' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: exportList,
    downloadFile (item) {
      if (item.fullPathUrl) {
        window.open(item.fullPathUrl);
      } else {
        const params = item.exportPath.split('#');
        const sessionId = params[0];
        const filePathId = params[1];
        const fileName = params[2] + '.xlsx';
        const queryUrl = item.queryUrl;
        downloadExcelFileAsyn({
          queryUrl,
          sessionId,
          filePathId,
          fileName,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
